import { Injectable } from '@angular/core';

@Injectable()
export abstract class ChangesNotSavedComponent {
    abstract isChanged(): boolean;
    abstract isSaved(): boolean;
}
